import { useRef } from "react";
import styles from "../../Styles/TextField.module.css";

const TextField = ({ text, description, initialText = "" }) => {
  const textRef = useRef();
  const textChangeHandler = () => {
    text(textRef.current.value);
  };
  const initialValueText = initialText !== "" ? initialText : null;
  return (
    <div className={styles.text}>
      <textarea
        className={styles.text__area}
        placeholder={description}
        ref={textRef}
        onChange={textChangeHandler}
        defaultValue={initialValueText}
      />
    </div>
  );
};
export default TextField;
